import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import Add from '@material-ui/icons/Add'

import { specialTheme, widthXS } from '../theme'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    color: specialTheme.colors.darkRed,
    backgroundColor: specialTheme.colors.white,
    '&:hover': {
      backgroundColor: specialTheme.colors.white,
    },
    marginTop: '1rem',
    padding: '0 15px',
    [theme.breakpoints.down(widthXS)]: {
      width: '100%',
      margin: '0 15px 0 0',
    },
    textTransform: 'initial',
    fontSize: '1rem',
    borderRadius: 0,
    height: 46,
    border: `1px solid ${specialTheme.colors.darkRed}`,
  },
}))

type ButtonSimplyProps = {
  children: any
  props?: any
  onClick: () => void
  loading?: boolean
}

const ButtonSimply = ({
  children,
  props,
  onClick,
  loading = true,
}: ButtonSimplyProps) => {
  const classes = useStyles()
  return loading ? (
    <Button
      type="button"
      onClick={onClick}
      className={classes.button}
      startIcon={<Add />}
      {...props}
    >
      {children}
    </Button>
  ) : (
    <CircularProgress />
  )
}

export default ButtonSimply
